<template>
  <el-drawer :visible.sync="visible" :with-header="false" :before-close="closeFn" :close-on-click-modal="false">
    <el-row style="margin-bottom: 20px">
      <el-col :span="23">
        <h1 style="margin-bottom: 20px">订单派车</h1>
      </el-col>
      <el-col :span="1">
        <el-button type="button" class="el-drawer__close-btn" @click="$emit('update:visible', false)">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </el-button>
      </el-col>
    </el-row>

    <p class="util-remark">{{ order.organizationName }}下的全部车辆</p>
    <div style="height: auto">
      <div style="padding-top: 6px">
        <el-select style="width: 100px" v-model="vehicleSeat" placeholder="座位数量" @change="search"
          :disabled="tabClickStatus" clearable>
          <el-option v-for="item in $const.SEATNUMBER" :key="item.value" :label="item.label"
            :value="item.value"></el-option>
        </el-select>
        <el-input style="width: 150px; margin-left: 10px" v-model="licenseNo" placeholder="搜索车辆号牌"
          maxlength="64"></el-input>
        <el-input style="width: 150px; margin-left: 10px" v-model="vehicleNo" placeholder="搜索车辆编号"
          maxlength="64"></el-input>
        <el-input style="width: 150px; margin-left: 10px" v-model="driverName" placeholder="搜索值班司机"
          maxlength="64"></el-input>
        <div style="margin-left: 10px; display: inline-block">
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="tabResetFn">重置</el-button>
        </div>
      </div>
      <el-table border ref="tableList" :data="table.content" :max-height="575" empty-text="该订单机构名称下，无可改派的车辆"
        style="width: 100%; margin-top: 8px" v-loading="loading">

        <el-table-column label="车辆号牌" min-width="100" show-overflow-tooltip prop="licenseNo">
        </el-table-column>
        <el-table-column label="车辆编号" min-width="100" show-overflow-tooltip prop="vehicleNo">
          <template slot-scope="{ row }">
            {{ row.vehicleNo ? row.vehicleNo : "-" }}
          </template>
        </el-table-column>
        <el-table-column label="座位数" min-width="100" show-overflow-tooltip prop="vehicleSeat">
          <template slot-scope="{ row }"> {{ row.vehicleSeat }}座 </template>
        </el-table-column>
        <el-table-column label="值班司机" show-overflow-tooltip min-width="110" prop="driverName">
          <template slot-scope="{ row }">
            {{ row.driverName ? row.driverName : "-" }}
          </template>
        </el-table-column>

        <el-table-column min-width="65" align="center" label="操作" v-slot="{ row }">
          <div style="padding: 0;" class="custom-action">
            <span v-if="!row.isRunning" @click.stop="seatSelection(row)" style="color: #0066ff; cursor: pointer">
              选择
            </span>
            <el-tooltip v-else effect="dark" content="车辆存在未结束的订单，暂无法选择" placement="top">
              <span style="color: #999;">
                选择 <i class="el-icon-warning"></i>
              </span>
            </el-tooltip>
          </div>
        </el-table-column>
      </el-table>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: "orderCharteredVehicle",
  props: {
    visible: {
      // 显隐
      default() {
        return false;
      },
    },
    order: {
      // 订单
      default() {
        return {};
      },
    }
  },
  data() {
    return {
      vehicleSeat: null,
      driverName: null,
      licenseNo: null,
      vehicleNo: null,
      tabClickStatus: false,
      pages: { page: 1, size: 1000 },
      // 选中的司机id
      driverId: "",
      // 选中的车辆id
      vehicleId: "",
      // 无限加载loading
      loading: false,
      // 车辆列表
      table: {
        content: [],
        total: 0,
      },
    };
  },
  computed: {
    noMore() {
      return (
        this.table.total !== 0 && this.table.content.length === this.table.total
      );
    },
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.load();
        } else {
          this.table = {
            content: [],
            total: 0,
          };
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    /* 初始显示事件 */
    async load() {
      // 清除司机车辆选中状态
      this.driverId = "";
      this.vehicleId = "";
      this.getVehicleList();
    },

    /* 点击查询 */
    async search() {
      this.table = {
        content: [],
        total: 0,
      };
      this.tabClickStatus = true;
      await this.getVehicleList();
      this.tabClickStatus = false;
    },

    async tabResetFn() {
      this.vehicleSeat = null;
      this.driverName = null;
      this.licenseNo = null;
      this.vehicleNo = null;

      this.table = {
        content: [],
        total: 0,
      };
      this.tabClickStatus = true;
      await this.getVehicleList();
      this.tabClickStatus = false;
    },

    /* 获取车辆列表 */
    async getVehicleList() {
      this.loading = true;
      let params = {
        organizationId: this.order.organizationId,
        vehicleSeat: this.vehicleSeat,
        driverName: this.driverName,
        licenseNo: this.licenseNo,
        vehicleNo: this.vehicleNo,
        vehicleId: this.order.vehicleId,
        ...this.pages,
      };
      let data = await this.$axios.get("/api/v1/manage/order/intercity/queryVehicleList", params);
      if (data && data.code === 1) {
        this.table = {
          content: data.data,
          total: data.total || 0,
        };
      }
      this.loading = false;
    },

    /* 车辆列表滚动分页 */
    async getVehicleListPush() {
      if (this.table.total <= this.pages.page * this.pages.size) {
        return;
      }
      this.loading = true;
      this.pages.page = this.pages.page + 1;
      let params = {
        vehicleSeat: this.vehicleSeat,
        driverName: this.driverName,
        licenseNo: this.licenseNo,
        vehicleNo: this.vehicleNo,
        vehicleId: this.order.vehicleId,
        ...this.pages,
      };
      let data = await this.$axios.get("/api/v1/manage/order/chartered/queryVehicleList", params);
      if (data && data.code === 1) {

        this.table = {
          content: this.table.content.concat(data.data),
          total: data.total || 0,
        };
      }
      this.loading = false;
    },

    /* 指派车辆 */
    async seatSelection(row) {
      if (this.order.charteredVehicleSeat > row.vehicleSeat) {
        this.$message.info("派车座位数量不符");
        return;
      }
      this.$confirm(`确认派单吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(async () => {
        let params = {
          orderId: this.order.id,
          driverId: row.driverId,
          vehicleId: row.vehicleId,
        };
        this.loading = true;
        let data = await this.$axios.post(this.order.vehicleId ? "/api/v1/manage/order/intercity/assign/again" : "/api/v1/manage/order/intercity/assign", params);
        this.loading = false;
        if (data && data.code === 1) {
          this.$message.success("指派成功");
          this.$emit("update:visible", false);
          this.$emit("confirm");
        }
      })
    },

    closeFn(done) {
      this.$emit("update:visible", false);
      done(false);
    },
  },
};
</script>
